export const STRIPE_PAYMENT_STATUS = {
  REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  SUCCEEDED: 'succeeded',
};